import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m8 5.013.782 1.394.303.539.595.169 1.752.499-1.037.904-.642.56.153.839.279 1.529-1.553-.721L8 10.43l-.632.294-1.553.721.279-1.53.153-.838-.642-.56-1.037-.905 1.752-.498.595-.169.303-.54L8 5.014ZM8 1.95 5.91 5.672 1.5 6.925l3.118 2.723-.799 4.38L8 12.085l4.18 1.942-.798-4.38 3.118-2.72-4.41-1.255-2.09-3.723H8Z"
      }
    )
  }
);
export {
  t as Star
};
